// extracted by mini-css-extract-plugin
module.exports = {"counter":"RaRRTbIw"};